import React, { useState } from 'react';
import {
	Button,
	Menu,
	MenuItem,
	Divider,
} from '@barracuda-internal/bds-core-v2';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';

interface RemediateDropdownProps {
	disabled: boolean;
	onSelect: (option: string) => void;
}

export const RemediateDropdown: React.FC<RemediateDropdownProps> = ({
	disabled,
	onSelect,
}) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleSelect = (option: string) => {
		handleClose();
		onSelect(option);
	};

	return (
		<>
			<Button
				disabled={disabled}
				variant="contained"
				onClick={handleClick}
				endIcon={<ArrowDropDown />}
				size="small"
			>
				Remediate
			</Button>
			<Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
				<MenuItem onClick={() => handleSelect('Quarantine')}>
					Quarantine
				</MenuItem>
				<MenuItem onClick={() => handleSelect('UnShare')}>
					UnShare
				</MenuItem>
				<MenuItem onClick={() => handleSelect('Dismiss')}>
					Dismiss
				</MenuItem>
				<Divider />
				<MenuItem onClick={() => handleSelect('Delete')}>
					Delete
				</MenuItem>
			</Menu>
		</>
	);
};
